// extracted by mini-css-extract-plugin
module.exports = {"cancelBtn":"TableHeader_cancelBtn__1LVKy","applyBtn":"TableHeader_applyBtn__2oLgf","buttonCont":"TableHeader_buttonCont__34-QX"};